import { render } from "./EmailPreviewPopUp.vue?vue&type=template&id=4b4b7fbc&scoped=true"
import script from "./EmailPreviewPopUp.vue?vue&type=script&lang=js"
export * from "./EmailPreviewPopUp.vue?vue&type=script&lang=js"

import "./EmailPreviewPopUp.vue?vue&type=style&index=0&id=4b4b7fbc&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4b7fbc"]])

export default __exports__